"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * @hidden
 */
function HeaderCell(props) {
    var clickProps = props.onClick ? {
        href: '#',
        onClick: props.onClick
    } : {};
    var defaultRendering = (React.createElement("a", __assign({ className: "k-link" }, clickProps),
        props.title || props.field || '\u00A0',
        props.children));
    return props.render ?
        props.render.call(undefined, defaultRendering, props) :
        defaultRendering;
}
exports.HeaderCell = HeaderCell;
//# sourceMappingURL=HeaderCell.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-data-tools@3.18.0_bwv2g72eb344voeanxti7iyzje/~/@progress/kendo-react-data-tools/dist/npm/header/HeaderCell.js
// module id = 301
// module chunks = 0